import React from 'react';
export function StickyBottomBar() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 py-3 px-4 md:py-4" data-id="element-131">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-132">
        <div className="flex items-center gap-2 text-gray-900 font-bold text-sm md:text-base" data-id="element-133">
          <span data-id="element-134">Limited Availability — Act Now</span>
          <span className="animate-pulse" data-id="element-135">👉</span>
        </div>
        <a href="https://shopglisera.com/products/glisera-anti-alcohol-patch" className="w-full sm:w-auto bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-3 px-8 rounded shadow-md transition-colors text-sm uppercase tracking-wide whitespace-nowrap" data-id="element-136">
          Get Glisera Now — Risk Free
        </a>
      </div>
    </div>;
}